import ExportIcon from "@material-ui/icons/GetApp";
import { YesNoField } from "components/fields/YesNoField";
import { OrderImportStatusColors, OrderImportStatusNames } from "entities/OrderImportStatus";
import React from "react";
import {
	Button,
	ChipField,
	Datagrid,
	List,
	Pagination,
	ReferenceField,
	ReferenceManyField,
	SingleFieldList,
	TextField,
} from "react-admin";
import { isNullUndEmpty } from "utils/general";

import { DateTimeField } from "../../../components/fields/DateFormatField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { OrderImportTracksFilters } from "./ListFilters";

const CustomDownloadButton = ({ record, label, href, onClick, renderCondition = () => true }) => {
	if (!(renderCondition && renderCondition(record))) return null;
	return (
		<Button
			label={label}
			variant="outlined"
			color="primary"
			href={typeof href === "function" ? href(record) : href}
			onClick={() => onClick && onClick(record)}
			startIcon={<ExportIcon />}
		/>
	);
};

const RelatedOrdersField = ({ record, source, ...rest }) =>
	record.order_ids.length > 0 ? (
		<ReferenceManyField
			{...rest}
			reference="orders"
			source={source}
			target="selected_ids"
			filter={{ draft_orders: true }}
			allowEmpty={true}
		>
			<SingleFieldList style={{ display: "block" }}>
				<ChipField source="id" size="small" />
			</SingleFieldList>
		</ReferenceManyField>
	) : null;

const TrucksTraffic = ({ permissions, ...props }) => {
	const anchor = React.useRef();

	React.useEffect(() => {
		anchor.current = document.createElement("a");
		document.body.appendChild(anchor.current);
		return () => {
			document.body.removeChild(anchor.current);
		};
	}, []);

	const downloadDataJson = (record) => {
		const jsonString = JSON.stringify(record.data, null, 2);
		const blob = new Blob([jsonString], { type: "application/json" });
		const objectUrl = window.URL.createObjectURL(blob);

		anchor.current.href = objectUrl;
		anchor.current.download = `order_import_${record.id}_data.json`;
		anchor.current.click();

		window.URL.revokeObjectURL(objectUrl);
	};

	const makeFilePreviewHref = (record) => record.preview_file_src;
	const inputFileRenderCondition = (record) => !isNullUndEmpty(record.preview_file_src);
	const dataRenderCondition = (record) => record.data?.length > 0;

	const rowStyle = (record) => ({
		backgroundColor: OrderImportStatusColors[record.status],
	});

	return (
		<List
			{...props}
			exporter={false}
			bulkActionButtons={false}
			sort={{ field: "created_at", order: "DESC" }}
			filters={<OrderImportTracksFilters />}
			pagination={<Pagination rowsPerPageOptions={[25, 50, 150]} />}
			perPage={50}
		>
			<Datagrid rowStyle={rowStyle}>
				<TextField source="id" />
				<SelectEnumField
					source="status"
					sortable={false}
					enumObj={OrderImportStatusNames}
					translate={false}
					reverse
				/>

				<DateTimeField source="created_at" withLocalTimeZone />

				<ReferenceField source="created_by" reference="users" link={false}>
					<TextField source="first_name" />
				</ReferenceField>

				<RelatedOrdersField source="order_ids" sortable={false} />

				<CustomDownloadButton
					label="resources.order-import-tracks.fields.import_file_button"
					href={makeFilePreviewHref}
					renderCondition={inputFileRenderCondition}
				/>
				<CustomDownloadButton
					label="resources.order-import-tracks.fields.import_data_button"
					onClick={downloadDataJson}
					renderCondition={dataRenderCondition}
				/>
			</Datagrid>
		</List>
	);
};

export default TrucksTraffic;
